/* ============================================================
   SE MERCI — PDP Tabs (Merrachi-Stil)
   Wandelt die nebeneinanderliegenden Collapsible-Tab-Blöcke
   (Beschreibung | Material | Versand …) in eine horizontale
   Tab-Navigation mit dezenter Unterlinie um.
   Progressive Enhancement: ohne JS bleiben es funktionierende
   Akkordeons.
   ============================================================ */
(function () {
  function buildGroup(blocks) {
    if (!blocks || blocks.length < 2) return;

    var parent = blocks[0].parentNode;
    var nav = document.createElement('div');
    nav.className = 'sf-tabs__nav';
    nav.setAttribute('role', 'tablist');

    var panels = [];

    blocks.forEach(function (block) {
      var btn = block.querySelector('.m-collapsible--button');
      var content = block.querySelector('.m-collapsible--content');
      if (!btn || !content) return;

      var title = (btn.textContent || '').trim();
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'sf-tabs__tab';
      tab.setAttribute('role', 'tab');
      tab.textContent = title;

      block.classList.add('sf-tabs__panel');

      var index = panels.length;
      tab.addEventListener('click', function () {
        activate(index);
      });

      nav.appendChild(tab);
      panels.push({ block: block, content: content, tab: tab });
    });

    if (panels.length < 2) return;

    parent.classList.add('sf-tabs--ready');
    parent.insertBefore(nav, blocks[0]);

    function activate(idx) {
      panels.forEach(function (p, j) {
        var on = j === idx;
        p.tab.classList.toggle('is-active', on);
        p.tab.setAttribute('aria-selected', on ? 'true' : 'false');
        p.block.classList.toggle('is-active', on);
        if (on) {
          p.content.hidden = false;
          p.content.removeAttribute('hidden');
        } else {
          p.content.hidden = true;
          p.content.setAttribute('hidden', '');
        }
      });
    }

    activate(0);
  }

  function init() {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;

    var all = Array.prototype.slice.call(document.querySelectorAll('.m-product-collapsible'));
    if (all.length < 2) return;

    // Nach gemeinsamem Eltern-Element gruppieren (aufeinanderfolgende Tabs).
    var groups = [];
    all.forEach(function (b) {
      var g = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].parent === b.parentNode) {
          g = groups[i];
          break;
        }
      }
      if (!g) {
        g = { parent: b.parentNode, blocks: [] };
        groups.push(g);
      }
      g.blocks.push(b);
    });

    groups.forEach(function (g) {
      buildGroup(g.blocks);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
